"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var InternalDropdownItem_1 = require("./InternalDropdownItem");

var dropdownConstants_1 = require("./dropdownConstants");

exports.DropdownItem = function (_a) {
  var children = _a.children,
      className = _a.className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'a' : _a$component,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isPlainText = _a.isPlainText,
      isPlainText = _a$isPlainText === void 0 ? false : _a$isPlainText,
      _a$isHovered = _a.isHovered,
      isHovered = _a$isHovered === void 0 ? false : _a$isHovered,
      href = _a.href,
      tooltip = _a.tooltip,
      _a$tooltipProps = _a.tooltipProps,
      tooltipProps = _a$tooltipProps === void 0 ? {} : _a$tooltipProps,
      listItemClassName = _a.listItemClassName,
      onClick = _a.onClick,
      ref = _a.ref,
      additionalChild = _a.additionalChild,
      customChild = _a.customChild,
      _a$tabIndex = _a.tabIndex,
      tabIndex = _a$tabIndex === void 0 ? -1 : _a$tabIndex,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      autoFocus = _a.autoFocus,
      _a$description = _a.description,
      description = _a$description === void 0 ? null : _a$description,
      styleChildren = _a.styleChildren,
      props = tslib_1.__rest(_a, ["children", "className", "component", "isDisabled", "isPlainText", "isHovered", "href", "tooltip", "tooltipProps", "listItemClassName", "onClick", "ref", "additionalChild", "customChild", "tabIndex", "icon", "autoFocus", "description", "styleChildren"]);

  return React.createElement(dropdownConstants_1.DropdownArrowContext.Consumer, null, function (context) {
    return React.createElement(InternalDropdownItem_1.InternalDropdownItem, Object.assign({
      context: context,
      role: "menuitem",
      tabIndex: tabIndex,
      className: className,
      component: component,
      isDisabled: isDisabled,
      isPlainText: isPlainText,
      isHovered: isHovered,
      href: href,
      tooltip: tooltip,
      tooltipProps: tooltipProps,
      listItemClassName: listItemClassName,
      onClick: onClick,
      additionalChild: additionalChild,
      customChild: customChild,
      icon: icon,
      autoFocus: autoFocus,
      styleChildren: styleChildren,
      description: description
    }, props), children);
  });
};

exports.DropdownItem.displayName = 'DropdownItem';